import styled from 'styled-components';

const Page = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const Image = styled.div`
  position: relative;
  background-repeat: no-repeat;
  background-image: url(https://img.alicdn.com/imgextra/i4/O1CN01kmBvb71dVQmI91lnT_!!6000000003741-2-tps-216-216.png);
  background-size: contain;
  background-position: center;
  width: 100px;
  height: 100px;
`;
const Title = styled.div`
  color: #474667;
  font-size: 14px;
  font-weight: normal;
  line-height: 24px;
  margin-top: 17px;
`;
const EmptyPage = ({ title = '' }) => {
  return (
    <Page>
      <Image />
      <Title>{title}</Title>
    </Page>
  );
};

export default EmptyPage;
